<div class="entity-address">
    <!--country-->
    <kendo-combobox #dropDownCountry class="col-line-1 entity-address-input" width="100%" [(ngModel)]="address.country"
        [data]="valueCountryList" (valueChange)="changeValueCountry($event)" placeholder="country/region"
        (focus)="dropDownCountry.toggle(true)" [allowCustom]="isCustom" [filterable]="true"
        (filterChange)="filterChangeCountry($event)">
    </kendo-combobox>
    <!--street1-->
    <div class="entity-street1" kendoTooltip position="right" tooltipClass="tooltip-adjust-right">
        <input class="tam-input col-line-1 entity-address-input" placeholder="street1" [maxLength]="1024"
            [(ngModel)]="address.street" (ngModelChange)="changeValueStreet($event)" />
        <smart-icon title="Address lookup"class="address-search" [name]="isShowSearchAddress?'searchAddress':'searchAddress-o'"
            (click)="clickSearchAddress()"></smart-icon>
        <tam-dashboard-map-autocomplete *ngIf="isShowSearchAddress" class="contact-autocomplete" [config]="mapConfig"
            (eventSubject$)="setSelectedAddress($event)">
        </tam-dashboard-map-autocomplete>
    </div>
    <!--street2-->
    <input class="tam-input col-line-1 entity-address-input" placeholder="street2" [maxLength]="1024"
        [(ngModel)]="address.street2" (ngModelChange)="changeValueStreet2($event)" />

    <div class="entity-address-combine entity-address-input">
        <!--city-->
        <input class="tam-input col-line-3 " placeholder="city" [(ngModel)]="address.city"
            (ngModelChange)="changeValueCity($event)" />
        <!--state-->
        <kendo-combobox class="col-line-3 address-state" #dropDownState [(ngModel)]="address.state"
            [data]="valueStateList" (valueChange)="changeValueState($event)" placeholder="state/province"
            (focus)="dropDownState.toggle(true)" [allowCustom]="isCustom" [filterable]="true"
            (filterChange)="filterChange($event)">
        </kendo-combobox>
        <!--zip-->
        <input class="tam-input col-line-3" placeholder="zip" [maxLength]="1024" [(ngModel)]="address.zip"
            (valueChange)="changeValueZip($event)" />
    </div>
</div>